import { render } from "./largeHorizontal.vue?vue&type=template&id=e0deb8be"
import script from "./largeHorizontal.vue?vue&type=script&lang=js"
export * from "./largeHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__